<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <rect
          id="Rectangle_1703"
          data-name="Rectangle 1703"
          class="cls-1"
          width="7"
          height="7"
          rx="2"
        />
        <path
          id="Rectangle_1704"
          data-name="Rectangle 1704"
          class="cls-1"
          d="M11.5,0h0A3.5,3.5,0,0,1,15,3.5h0A3.5,3.5,0,0,1,11.5,7h0A3.5,3.5,0,0,1,8,3.5H8A3.5,3.5,0,0,1,11.5,0Z"
        />
        <rect
          id="Rectangle_1705"
          data-name="Rectangle 1705"
          class="cls-1"
          x="8"
          y="8"
          width="7"
          height="7"
          rx="2"
        />
        <rect
          id="Rectangle_1706"
          data-name="Rectangle 1706"
          class="cls-1"
          y="8"
          width="7"
          height="7"
          rx="2"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
